import React, { createContext, useEffect, useState } from "react";
import appConfig from "../config/appConfig";

export interface ThemeContextProps {
	theme: string;
	toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(
	undefined,
);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [theme, setTheme] = useState<string>(
		(localStorage.getItem("theme") || appConfig.theme).trim().toLowerCase(),
	);

	const toggleTheme = () => {
		const newTheme = theme === "light" ? "dark" : "light";
		setTheme(newTheme);
		localStorage.setItem("theme", newTheme);
	};

	useEffect(() => {
		document.documentElement.classList.remove("light", "dark");

		if (["light", "dark"].includes(theme)) {
			document.documentElement.classList.add(theme);
		} else {
			console.error("Invalid theme value:", theme);
		}
	}, [theme]);

	return (
		<ThemeContext.Provider value={{ theme, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};
